/**
 * @description NA通知H5开始输入
 */
const NA_START_INPUT = 'com.baidu.newapp.na.start_input';

/**
 * @description 吊起键盘，通知H5滚动到底部
 */
const NA_SEND_SCROLL_TO_BOTTOM = 'com.baidu.newapp.na.scroll_to_bottom';

/**
 * @description 新建会话，H5拿到最新sessionId同步端
 */
const H5_SET_SESSION_INFO = 'com.baidu.newapp.h5.set_session_info';

/**
 * @description 切换语音模式，0关、1开
 */
const H5_CHANGE_VOICE_SWITCH = 'com.baidu.newapp.h5.voice_broadcast_switch';

/**
 * @description H5同步给NA语聊页sug
 */
const H5_SET_INSPIRATION_SUG = 'com.baidu.newapp.h5.set_inspiration_sug';
/**
 * @description 发送可以点击停止回答事件
 */
const H5_SEND_ENABLE_STOP_BUTTON = 'com.baidu.newapp.h5.enable_stop_button';

/**
 * @description 发送显示停止回答事件
 */
const H5_SEND_SHOW_STOP_BUTTON = 'com.baidu.newapp.h5.show_stop_button';

/**
 * @description 监听ask补充信息
 */
const NA_CHAT_SEND_ADD_VOICE_INFO = 'com.baidu.newapp.na.chat_send_add_voice_info';

/**
 * @description 监听webview切换
 */
const NA_WEBVIEW_VISIBLE_CHANGED = 'com.baidu.newapp.na.webview_visible_changed';

/**
 * @description 监听webview可见
 */
const NA_WEBVIEW_PAGE_SHOW = 'com.baidu.newapp.na.notify_pageshow';

/**
 * @description NA通知H5获取历史消息
 */
const NA_SEND_CHAT_GET_HISTORY = 'com.baidu.newapp.na.chat_get_history';

/**
 * @description 多模回主对话NA通知H5获取历史消息
 */
const NA_SEND_MULTI_CHAT_GET_HISTORY = 'com.baidu.newapp.na.multi_chat_get_history';

/**
 * @description 退出二级对话页通知h5拉历史
 */
const NA_SEND_SECOND_CHAT_GET_HISTORY = 'com.baidu.newapp.na.second_chat_get_history';

/**
 * @description NA向H5发送欢迎语信息
 */
const NA_SEND_CHAT_WELCOME = 'com.baidu.newapp.na.chat_welcome';

/**
 * @description NA向H5发送主动推荐卡(欢迎语)信息(客户端热启阶段)
 */
const NA_SEND_CHAT_HOT_WELCOME = 'com.baidu.newapp.na.chat_hot_welcome';

/**
 * @description NA向H5发送输入框的内容，上屏至右侧
 */
const NA_SEND_CHAT_ASK = 'com.baidu.newapp.na.chat_send';

/**
 * @description 长按气泡中，NA将选中的内容传递给H5
 */
const NA_SEND_CHAT_LONG_TAP = 'com.baidu.newapp.na.chat_long_tap';

/**
 * @description NA将创建分享后的response传递给H5
 */
const NA_SEND_SHARE_CREATE = 'com.baidu.newapp.na.share_create';

/**
 * @description 当H5选中一些会话后，NA点击取消，通知H5
 */
const NA_SEND_CANCEL_SELECTED = 'com.baidu.newapp.na.cancel_selected';

/**
 * @description 当NA停止回答时，通知H5
 */
const NA_SEND_CHAT_STOP_ANSWER = 'com.baidu.newapp.na.chat_stop_answer';

/**
 * @description  H5将回答上屏完毕，通知NA可以继续提问
 */
const H5_ENABLE_ASK = 'com.baidu.newapp.h5.chat_enable_ask';

/**
 * @description  H5引导完毕，通知NA展示电话引导
 */
const H5_SHOW_PHONE_GUIDE = 'com.baidu.newapp.h5.show_phone_guide';

/**
 * @description  H5引导上屏完毕，通知NA
 */
const H5_GUIDE_FINISH = 'com.baidu.newapp.h5.all_guide_finish';

/**
 * @description  NA引导完毕，通知H5
 */
const NA_GUIDE_FINISH = 'com.baidu.newapp.na.all_guide_finish';

/**
 * @description  H5已经ready了
 */
const H5_READY = 'com.baidu.newapp.h5.ready';

/**
 * @description  H5发送文字给NA，NA将文字放置于输入框
 */
const H5_SET_INPUT_ASK = 'com.baidu.newapp.h5.set_input_ask';

/**
 * @description 长按气泡-多选-H5选择taldId，给NA
 */
const H5_SEND_SELECTED_TALK = 'com.baidu.newapp.h5.chat_long_tap';

/**
 * @description 将多选的数据实时的通知给端上
 */

const H5_CREATE_VIDEO_TAP = 'com.baidu.newapp.h5.chat_create_video_tap';

/**
 * @description 全选后将内容同步给端（仅Android需要，iOS自己取到）
 * @description 需要给IOS选区的位置信息，以及移除选区时通知IOS
 */
const H5_SEND_ALL_SELECTED_INFO = 'com.baidu.newapp.h5.all_selected_info';

/**
 * @description 聊天数量达到限制，通知端
 */
const H5_SEND_MESSAGE_REACHED_LIMIT = 'com.baidu.newapp.h5.message_reached_limit';

/**
 * @description 端通知H5设置信息
 */
const NA_SEND_SETTING_INFO = 'com.baidu.newapp.na.send_setting_info';

/**
 * @description 端通知灵感中心更新
 */
const NA_SEND_PROMPT_UPDATE = 'com.baidu.newapp.na.prompt_lifecycle';
/**
 * @description 端通知H5设置信息
 */
const NA_SEND_CHAT_REST = 'com.baidu.newapp.na.chat_reset';
/**
 * @description 端通知H5字体大小
 */
const NA_SEND_FONT_SIZE = 'com.baidu.newapp.na.font_size_change';
/**
 * @description NA通知H5图片上传进度
 */
const NA_SEND_IMAGE_UPLOAD_PROCESS = 'com.baidu.newapp.na.upload_process';

/**
 * @description H5通知NA重新上传图片
 */
const H5_SEND_IMAGE_REUPLOAD = 'com.baidu.newapp.h5.send_reupload';

/**
 * @description NA和H5变更数据信息-关注
 */
const INTERACTION_FOLLOW_CHANGE = 'com.baidu.newapp.channel.interaction_follow_change';

/**
 * @description NA和H5变更数据信息-点赞
 */
const INTERACTION_LIKE_CHANGE = 'com.baidu.newapp.channel.interaction_like_change';

/**
 * @description 端通知H5自动续费取消成功
 */
const CANCEL_MONTHLY_PAY_SUCCESS = 'com.baidu.newapp.channel.cancel_monthly_pay_success';

/**
 * @description h5监听及通知关闭页面
 */
const H5_CLOSE_PAGE = 'com.baidu.newapp.channel.page_close';

/**
 * @description AI PPT 大纲页面监听二次编辑
 */
const UPDATE_OUTLINE = 'com.baidu.newapp.channel.outline_edit';

/**
 * @description 错题本页面监听删除、修改
 */
const UPDATE_WRONG_BOOK = 'com.baidu.newapp.channel.wrong_book_update';

/**
 * @description 反馈面板关闭通知
 */
const NA_FEEDBACK_CLOSE = 'com.baidu.newapp.na.notify_feedbackClose';

/**
 * @description 通知端伙伴动画播放完成
 */
const H5_SEND_CHARACTER_ANIMATION_DONE = 'com.baidu.newapp.h5.character_animation_done';

/**
 * @description 隐藏伙伴动画
 */
const NA_HIDE_CHARACTER_ANIMATION = 'com.baidu.newapp.na.hide_character_animation';

/**
 * @description 通知端取消多选
 */
const H5_SEND_CANCEL_MULTIPLE_SELECT = 'com.baidu.newapp.h5.cancel_multiple_select';

/**
 * @description 端通知H5会员支付协议勾选
 */
const NA_SEND_PAY_PROTOCOL_SELECT = 'com.baidu.newapp.na.pay_protocol_select';

/**
 * @description pc端使用，回答为高风险时通知pc重置按钮状态
 */
const HIGH_RISK_RESET_FOR_PC = 'highRiskResetForPC';

/**
 *  @description 端上通知h5切换模型的状态
 */
const NA_SEND_MODEL_ID = 'com.baidu.newapp.na.model_id';

/**
 *   @description 端上通知h5切换模型的状态 4.12改版的大类别模型切换（deepseek、auto等模型切换）
 */
const NA_SEND_MODELS_CHANGE = 'com.baidu.newapp.na.models_change';

/**
 * @description NA通知H5切换题目
 */
const NA_CHANGE_QUESTION_IMAGE = 'com.baidu.newapp.na.change_question';

/**
 * @description H5通知NA切换题目
 */
const H5_CHANGE_QUESTION_IMAGE = 'com.baidu.newapp.h5.change_question';

/**
 * @description 支付成功
 */
const NA_PAY_COIN_SUCCESS = 'com.baidu.newapp.na.pay_success';

/**
 * @description 日卡购买成功
 */
const NA_PAY_DAY_CARD_SUCCESS = 'com.baidu.newapp.na.day_card_pay_success';

/**
 * @description 灵感币购买成功通知h5更新余额,全局
 */
const NA_GLOBAL_PAY_COIN_SUCCESS = 'com.baidu.newapp.channel.coin_pay_success';

/**
 * @description 日卡购买服务下线
 */
const NA_DAY_CARD_PAY_SERVICE_OFFLINE = 'com.baidu.newapp.na.day_card_pay_service_offline';

/**
 * @description 用户选中灵感币单次解锁模式
 */
const NA_SELECT_PAY_COIN_SINGLE = 'com.baidu.newapp.na.model_unlock_select_single_pass';

/**
 * @description 发送会话初始化时一些信息，例如灵感币对话使用eb40样式
 */
const H5_SEND_CHAT_INIT_CONFIG = 'com.baidu.newapp.h5.data_config_map';

/**
 * @description 语音模式，1进入，-1退出
 */
const NA_SEND_VOICE_MODE = 'com.baidu.newapp.na.voice_mode';

/**
 * @description 发送 tts 开始播放的状态
 */
const H5_SEND_TTS_START = 'com.baidu.newapp.h5.tts_start';

/**
 * @description 发送语音模式错误
 */
const H5_SEND_VOICE_MODE_ERROR = 'com.baidu.newapp.h5.voice_mode_error';

/**
 * @description NA 告诉 FE 发送 UBC 日志
 */
const NA_NOTIFY_TO_SEND_UBC = 'com.baidu.newapp.na.notify_fe_ubc';

/**
 * @description NA 向 H5 下发运营活动任务
 */
const NA_NOTIFY_TO_SEND_TASK = 'com.baidu.newapp.na.launch_task';

/**
 * @description H5 向 NA 发起完成运营活动任务
 */
const H5_NOTIFY_TO_SEND_TASK = 'com.baidu.newapp.h5.complete_task';

/**
 *  @description 端上通知h5的全局消息
 */
const NA_SEND_GLOBE_MESSAGE = 'com.baidu.newapp.na.globe_message';

/**
 * @description H5 向 NA 发送欢迎语展示信息
 */
const H5_SEND_WELCOME_DISPLAY = 'com.baidu.newapp.h5.welcome_display';

/**
 * @description NA 告诉 FE 本地相册选中了照片
 */
const NA_NOTIFY_SELECT_IMAGE = 'com.baidu.newapp.na.image_picker_select_image_complete';

/**
 * @description NA 告诉 FE 照片上传结果
 */
const NA_NOTIFY_IMAGE_UPLOAD = 'com.baidu.newapp.na.image_picker_upload_image_complete';

/**
 * @description H5 向 NA 发送是否有上屏消息（拉历史或者主动聊过天）
 */
const H5_SEND_HAS_TALKED = 'com.baidu.newapp.h5.chatpage_current_has_talked';

/*
 * @description H5 向 NA 发送欢迎语展示信息
 */
const H5_SEND_SHOW_DYNAMIC_EFFECT = 'com.baidu.newapp.h5.show_dynamic_effect';

/**
 * @description H5 向 NA 发送欢迎第一个 chunk
 */
const H5_SEND_RECEIVE_CHUNK = 'com.baidu.newapp.h5.receive_chunk';

/**
 * @description H5 向 NA 通知新建会话了
 */
const H5_SEND_NEW_SESSION = 'com.baidu.newapp.h5.chat_reseted_or_new_chat';

/**
 * @description NA 向 H5 通知有新的互动消息了，去拉一下
 */
const NA_SEND_GET_NEW_INTERACTION = 'com.baidu.newapp.na.get_new_interaction';

/**
 * @description NA 向 H5 通知消息tab即将隐藏
 */
const NA_SEND_INTERACTION_HIDE = 'com.baidu.newapp.na.interaction_hide';

/**
 * @description NA 向 H5 发送IM消息通知
 */
const NA_SEND_CHAT_IM_MESSAGE = 'com.baidu.newapp.na.chat_im';

/**
 * @description NA 向 H5 通知助手形象状态变更
 */
const NA_SEND_ASSISTANT_IMAGE_STATUS_CHANGE = 'com.baidu.newapp.na.assistant_image_status_change';

/**
 * @description H5向NA发送收藏状态变更通知
 */
const H5_SEND_COLLECT_STATUS_CHANGE = 'com.baidu.newapp.channel.interaction_collect_change';

/**
 * @description H5 向 NA 通知发送基本已经渲染出首帧了
 */
const H5_SEND_FIRST_FRAME_ALREADY_STATUS = 'com.baidu.newapp.h5.first_data_already';

/**
 * @description NA向H5发通知
 */
const NA_SEND_IMAGE_UPLOAD_COMPLETE = 'com.baidu.newapp.na.agent_image_upload_complete';

/**
 * @description 全局事件监听通道,AI照相馆页面间消息通知
 */
const INTERACTION_PHOTO_NOTICE = 'com.baidu.newapp.channel.interaction_photo_update';

/**
 * @description NA同步H5音乐卡播放状态变更
 */
const NA_SEND_AUDIO_STATUS_CHANGE = 'com.baidu.channel.audio.status.change';

/**
 * @description NA向H5发送展示多模规则sug
 */
const NA_SEND_SHOW_RULE_SUG = 'com.baidu.newapp.na.show_rule_sug';

/**
 * @description NA向H5发送展示多模多图sug
 */
const NA_SEND_SHOW_MULTI_IMAGE_SUG = 'com.baidu.newapp.na.show_multi_image_sug';

/**
 * @description NA 向 H5 发送识图区域发生变化
 */
const NA_SEND_RECOGNITION_AREA_CHANGE = 'com.baidu.newapp.na.recognition_area_changed';

/**
 * @description H5同步给NA提问的引用数据
 */
const H5_SET_ASK_QUOTE = 'com.baidu.newapp.h5.set_ask_quote';

/**
 * @description NA 向 H5 发送当前TTS语音改变后的信息
 */
const NA_SEND_TTS_CONFIG_CHANGE = 'com.baidu.newapp.na.voice_update';

/**
 * @description H5 二级页打开声音设置面板
 */
const H5_OPEN_TTS_SETTING_PANEL = 'com.baidu.newapp.h5.open_voice_setting_panel';

/**
 * @description 前端通知NA到达answer底部的边界条件
 */
const H5_SEND_LATEST_ANSWER_REACH_BOTTOM = 'com.baidu.newapp.h5.chat_shake_whole_bubble_show';

/**
 * @description NA通知前端出弱引导
 */
const NA_SEND_SHAKE_SHOW_GUIDANCE = 'com.baidu.newapp.na.interaction_shake_show_guidance';

/**
 * @description NA 向 H5 是否有新手任务入口
 */
const NA_SEND_NEW_USER_TASK_ENTRY = 'com.baidu.newapp.na.send_new_user_task_entrance';

/**
 * @description NA通知Scheme中的参数
 */
const NA_CHAT_CMD = 'com.baidu.newapp.na.chat_cmd';

/**
 * @description NA和H5变更帖子数据信息
 */
const INTERACTION_POST_CHANGE = 'com.baidu.newapp.channel.interaction_post_change';

/**
 * @description 通知端上输入框placeholder内容
 */
const H5_SEND_INPUT_HINT = 'com.baidu.newapp.h5.set_input_hint';
/**
 * @description 通知NA设置框上引导位
 */
const SET_INPUT_BOX_GUIDE = 'com.baidu.newapp.h5.data_config_extra';

/**
 * @description h5通知主对话文件上屏
 */
const H5_SEND_SET_INPUT_ASK = 'com.baidu.newapp.channel.set_input_ask';

/**
 * @description NA发送社区渲染依赖JSON给h5
 */
const NA_SEND_COMMUNITY_DATA = 'com.baidu.newapp.na.community_page_data';

/**
 * @description h5通知na展示删除消息按钮
 */
const H5_SEND_DELETE_MSG_SHOW_STATE = 'com.baidu.newapp.h5.delete_msg_show_state';

/**
 * @description na通知h5删除提交
 */
const NA_SEND_DELETE_MSG_CONFIRM = 'com.baidu.newapp.na.delete_msg_confirm';

/**
 * @description h5通知na删除完成
 */
const H5_SEND_DELETE_MSG_COMPLETE = 'com.baidu.newapp.h5.delete_msg_complete';

/**
 * @description NA通知H5展示删除本地indexDb数据
 */
const NA_SEND_DELETE_LOCAL_MSGS = 'com.baidu.newapp.na.delete_local_msgs';

/**
 * @description NA通知H5展示删除当前sessionList数据
 */
const NA_SEND_DELETE_UI_MSGS = 'com.baidu.newapp.na.delete_ui_msgs';

/**
 * @description NA通知删除智能体bot
 */
const NA_SEND_DELETE_BOT = 'com.baidu.newapp.na.delete_bot';

/**
 * @description NA通知H5框上引导信息 4.6新增
 */
const NA_SEND_INPUT_GUIDE = 'com.baidu.newapp.na.input_guide';

/**
 * @description 助手形象切换
 */
const NA_SEND_CHARACTER_IMAGE_CHANGE = 'com.baidu.newapp.na.character_image_change';

/**
 * @description NA通知运营配置变化 4.12新增
 */
const NA_SEND_CHAT_LCP = 'com.baidu.newapp.na.chat_lcp';

/**
 * @description NA通知云控接口数据变更 4.12新增
 */
const NA_SEND_CLOUD_CONFIG_UPDATE = 'com.baidu.newapp.na.cloud_config_update';

/**
 * @description H5调用上屏检测 4.12新增
 */
const H5_SEND_CHAT_SCREEN_CHECK = 'com.baidu.newapp.h5.chat_screen_check';

/**
 * @description NA通知上屏检测状态 4.12新增
 */
const NA_SEND_CHAT_SCREEN_STATUS = 'com.baidu.newapp.na.chat_screen_status';

/**
 * @description NA 通知 FE 微信文件选择结果
 */
const NA_SEND_WECHAT_SELECT_DOC_DATA = 'com.baidu.newapp.na.wx_select_doc_data';

/**
 * @description 我的创作页面 NA 通知 FE 删除创作
 */
const NA_SEND_MYCREATION_DELETE_WORK = 'com.baidu.newapp.na.delete_works_success_data';
/**
 * @description 我的创作页面 H5 通知 FE 删除创作
 */
const H5_SEND_MYCREATION_DELETE_WORK = 'com.baidu.newapp.h5.delete_works_success_data';

/**
 * @description NA 向 H5 通知底部导航栏高度变化
 */
const NA_SEND_BOTTOM_NAV_BAR_HEIGHT_CHANGE = 'com.baidu.newapp.na.bottom_nav_bar_height_change';

/**
 * @description NA 向 H5 通知刷新页面
 */
const NA_SEND_PAGE_REFRENSH = 'com.baidu.newapp.na.notify_page_refresh';

/**
 * @description NA 向 H5 通知删除/编辑
 */
const NA_SEND_BOTTOM_MENU_CLICK = 'com.baidu.newapp.na.notify_bottom_menu_click';
/**
 * @description NA 向 H5 通知当前na正在滚动
 */
const NA_SEND_PAGE_SCROLLING = 'com.baidu.newapp.na.page_scrolling';

export {
    CANCEL_MONTHLY_PAY_SUCCESS,
    H5_CHANGE_QUESTION_IMAGE,
    H5_CHANGE_VOICE_SWITCH,
    H5_CLOSE_PAGE,
    H5_CREATE_VIDEO_TAP,
    H5_ENABLE_ASK,
    H5_GUIDE_FINISH,
    H5_NOTIFY_TO_SEND_TASK,
    H5_OPEN_TTS_SETTING_PANEL,
    H5_READY,
    H5_SEND_ALL_SELECTED_INFO,
    H5_SEND_CANCEL_MULTIPLE_SELECT,
    H5_SEND_CHARACTER_ANIMATION_DONE,
    H5_SEND_CHAT_INIT_CONFIG,
    H5_SEND_CHAT_SCREEN_CHECK,
    H5_SEND_COLLECT_STATUS_CHANGE,
    H5_SEND_DELETE_MSG_COMPLETE,
    H5_SEND_DELETE_MSG_SHOW_STATE,
    H5_SEND_ENABLE_STOP_BUTTON,
    H5_SEND_FIRST_FRAME_ALREADY_STATUS,
    H5_SEND_HAS_TALKED,
    H5_SEND_IMAGE_REUPLOAD,
    H5_SEND_INPUT_HINT,
    H5_SEND_LATEST_ANSWER_REACH_BOTTOM,
    H5_SEND_MESSAGE_REACHED_LIMIT,
    H5_SEND_MYCREATION_DELETE_WORK,
    H5_SEND_NEW_SESSION,
    H5_SEND_RECEIVE_CHUNK,
    H5_SEND_SELECTED_TALK,
    H5_SEND_SET_INPUT_ASK,
    H5_SEND_SHOW_DYNAMIC_EFFECT,
    H5_SEND_SHOW_STOP_BUTTON,
    H5_SEND_TTS_START,
    H5_SEND_VOICE_MODE_ERROR,
    H5_SEND_WELCOME_DISPLAY,
    H5_SET_ASK_QUOTE,
    H5_SET_INPUT_ASK,
    H5_SET_INSPIRATION_SUG,
    H5_SET_SESSION_INFO,
    H5_SHOW_PHONE_GUIDE,
    HIGH_RISK_RESET_FOR_PC,
    INTERACTION_FOLLOW_CHANGE,
    INTERACTION_LIKE_CHANGE,
    INTERACTION_PHOTO_NOTICE,
    INTERACTION_POST_CHANGE,
    NA_CHANGE_QUESTION_IMAGE,
    NA_CHAT_CMD,
    NA_CHAT_SEND_ADD_VOICE_INFO,
    NA_DAY_CARD_PAY_SERVICE_OFFLINE,
    NA_FEEDBACK_CLOSE,
    NA_GLOBAL_PAY_COIN_SUCCESS,
    NA_GUIDE_FINISH,
    NA_HIDE_CHARACTER_ANIMATION,
    NA_NOTIFY_IMAGE_UPLOAD,
    NA_NOTIFY_SELECT_IMAGE,
    NA_NOTIFY_TO_SEND_TASK,
    NA_NOTIFY_TO_SEND_UBC,
    NA_PAY_COIN_SUCCESS,
    NA_PAY_DAY_CARD_SUCCESS,
    NA_SELECT_PAY_COIN_SINGLE,
    NA_SEND_ASSISTANT_IMAGE_STATUS_CHANGE,
    NA_SEND_AUDIO_STATUS_CHANGE,
    NA_SEND_BOTTOM_MENU_CLICK,
    NA_SEND_BOTTOM_NAV_BAR_HEIGHT_CHANGE,
    NA_SEND_CANCEL_SELECTED,
    NA_SEND_CHARACTER_IMAGE_CHANGE,
    NA_SEND_CHAT_ASK,
    NA_SEND_CHAT_GET_HISTORY,
    NA_SEND_CHAT_HOT_WELCOME,
    NA_SEND_CHAT_IM_MESSAGE,
    NA_SEND_CHAT_LCP,
    NA_SEND_CHAT_LONG_TAP,
    NA_SEND_CHAT_REST,
    NA_SEND_CHAT_SCREEN_STATUS,
    NA_SEND_CHAT_STOP_ANSWER,
    NA_SEND_CHAT_WELCOME,
    NA_SEND_CLOUD_CONFIG_UPDATE,
    NA_SEND_COMMUNITY_DATA,
    NA_SEND_DELETE_BOT,
    NA_SEND_DELETE_LOCAL_MSGS,
    NA_SEND_DELETE_MSG_CONFIRM,
    NA_SEND_DELETE_UI_MSGS,
    NA_SEND_FONT_SIZE,
    NA_SEND_GET_NEW_INTERACTION,
    NA_SEND_GLOBE_MESSAGE,
    NA_SEND_IMAGE_UPLOAD_COMPLETE,
    NA_SEND_IMAGE_UPLOAD_PROCESS,
    NA_SEND_INPUT_GUIDE,
    NA_SEND_INTERACTION_HIDE,
    NA_SEND_MODEL_ID,
    NA_SEND_MODELS_CHANGE,
    NA_SEND_MULTI_CHAT_GET_HISTORY,
    NA_SEND_MYCREATION_DELETE_WORK,
    NA_SEND_NEW_USER_TASK_ENTRY,
    NA_SEND_PAGE_REFRENSH,
    NA_SEND_PAGE_SCROLLING,
    NA_SEND_PAY_PROTOCOL_SELECT,
    NA_SEND_PROMPT_UPDATE,
    NA_SEND_RECOGNITION_AREA_CHANGE,
    NA_SEND_SCROLL_TO_BOTTOM,
    NA_SEND_SECOND_CHAT_GET_HISTORY,
    NA_SEND_SETTING_INFO,
    NA_SEND_SHAKE_SHOW_GUIDANCE,
    NA_SEND_SHARE_CREATE,
    NA_SEND_SHOW_MULTI_IMAGE_SUG,
    NA_SEND_SHOW_RULE_SUG,
    NA_SEND_TTS_CONFIG_CHANGE,
    NA_SEND_VOICE_MODE,
    NA_SEND_WECHAT_SELECT_DOC_DATA,
    NA_START_INPUT,
    NA_WEBVIEW_PAGE_SHOW,
    NA_WEBVIEW_VISIBLE_CHANGED,
    SET_INPUT_BOX_GUIDE,
    UPDATE_OUTLINE,
    UPDATE_WRONG_BOOK,
};
